import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
import { EventDetailsEntity } from "../event-details/event-details.entity";
import { EventscategoryEntity } from "../eventcategory/eventcategory.entity";
import { UserEntity } from "../user/user.entity";
import { VillageEntity } from "../village/village.entity";
import { EventFilesEntity } from "./event-files.entity";
import { EventRSVPEntity } from "./event-rsvp.entity";

@Entity('event')
export class EventsEntity {

    @PrimaryGeneratedColumn('increment',{name:'id'}) Id: number;
    @Column({
        type: 'varchar',
        nullable: false,
        length: '500',
        name: 'event_title',
    })
    eventTitle: string;
    @Column({
        type: 'varchar',
        nullable: false,
        length: '500',
        name: 'event_desc',
    })
    eventDesc: string;
    @Column({
        type: 'int',
        nullable: true,
        name: 'village_id',
    })
    villageId: number | null;
    @Column("int",{
        nullable:true,
        name:"category_id"
    })
    categoryId:number;
    @Column({
        nullable:false,
        name: "event_start_date",
        type:'date'
    })
    eventStartDate: Date;
    @Column({
        nullable:false,
        length:"500",
        name: "event_start_time",
        type:'varchar'
    })
    eventStartTime: string;
    @Column({
        nullable:false,
        name: "event_end_date",
        type:'date'
    })
    eventEndDate: Date;
    @Column({
        nullable:false,
        length:"500",
        name: "event_end_time",
        type:'varchar'
    })
    eventEndTime: string;
    @Column("int",{
        nullable:false,               
        name:"public",
        default:0,
    })
    public:number;
    @Column("boolean",{
        nullable:false,
        default:true,               
        name:"status"
    })
    status:boolean;
    @Column("int",{
        nullable:false,
        name:"user_id"
    })
    userId:number;
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;
    @Column("int", {
        nullable: true,
        name: "created_user"
    })
    createdUser: number | null;
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;
    @Column("int", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: number | null;
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;   
    @OneToMany(() => EventDetailsEntity, (eventdetails: EventDetailsEntity) => eventdetails.event)
    eventdetails: EventDetailsEntity;
    @OneToMany(() =>EventFilesEntity,(eventfiles: EventFilesEntity) => eventfiles.event)
    eventfiles: EventFilesEntity;
    @OneToMany(()=>EventRSVPEntity,(eventrsvp:EventRSVPEntity)=>eventrsvp.event)
    eventrsvp:EventRSVPEntity;
    @ManyToOne(()=>UserEntity, (user:UserEntity)=>user.event)
    @JoinColumn({name:"user_id"})
    user:UserEntity;
    @ManyToOne(()=>EventscategoryEntity, (eventcategory:EventscategoryEntity)=>eventcategory.event)
    @JoinColumn({name:"category_id"})
    eventcategory:EventscategoryEntity;
    @ManyToOne(() => VillageEntity, (village:VillageEntity) => village.event)
    @JoinColumn({name:"village_id"})
    village:VillageEntity;
}